'use client';

import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { StatValue, ShowMoreLink } from './styles';

const CHAR_LIMIT = 300;

interface TruncatedTextProps {
  text: string;
}

export const TruncatedText = ({ text }: TruncatedTextProps) => {
  const t = useTranslations('brokerOfficesDetails');
  const [expanded, setExpanded] = useState(false);

  if (text.length <= CHAR_LIMIT) {
    return <StatValue>{text}</StatValue>;
  }

  if (expanded) {
    return (
      <StatValue>
        {text} <ShowMoreLink onClick={() => setExpanded(false)}>{t('showLess')}</ShowMoreLink>
      </StatValue>
    );
  }

  return (
    <StatValue>
      {text.slice(0, CHAR_LIMIT)}…{' '}
      <ShowMoreLink onClick={() => setExpanded(true)}>{t('showMore')}</ShowMoreLink>
    </StatValue>
  );
};
